<div class="col-sm-12 detail" *ngIf="!isEmpty && !isEdit" style="height: 100%" (click)="common.outSide($event)">
  <div class="header col-sm-12">
    <div class="col-sm-9" style="white-space: nowrap;">
      <h2 style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden;"> Nomenclatures négociées du client {{detail.nomClient}} </h2>
    </div>
    <div class="col-sm-3 text-right">
      <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer</button>
      <button class="btn-header uppercase actionPricipal" id="valide" (click)="saveNomenclatureNego()"> Valider</button>
      <!--div>
        <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
        <label class="text-left uppercase text-underline historique">Voir les documents</label>
      </div-->
    </div>
  </div>

  <div class="col-sm-12 ligneBon liste">
    <ngx-datatable *ngIf="renderTable" style="height: 100%" class="material" [rows]="listNomenclature || []"
                   [columnMode]="'force'" 
                   [headerHeight]="35" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'"
                   [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
                   [loadingIndicator]="loadingIndicator" [selected]="selected">

      <ngx-datatable-column prop="code">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Article </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Libellé </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <span> {{value}} </span>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="articleContenu.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Contenu </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{row.articleContenu ? value || row.articleContenu.libelleObjetEntite : 'Tous'}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="chantier.numChantier">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Chantier </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{row.chantier && row.chantier.id ? (value || row.chantier.responsable) : 'Tous'}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="typeContenant.libelleObjetEntite">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Contenant </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{value || 'Tous'}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="agence.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Agence </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{ row.agence &&  row.agence.id ? (value || row.agence.libelleObjetEntite) : 'Toutes'}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column prop="exu.nom">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                     let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Exutoire </span>
            <div class=" shorticone pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          {{row.exu && row.exu.id ? (value || row.exu.libelleObjetEntite) : 'Tous'}}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                            [resizeable]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <div class="text-center">
            <button class="btn-detail" (click)="rowIndexEdit = rowIndex;showFormEdit(row);">
              <i class="fa fa-pencil"></i>
            </button>
            <button class="btn-detail" (click)="deleteLigne(row, rowIndex)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="addLigne col-sm-12 uppercase">
    <div class="col-sm-7 text-left">
      <button class="btn-add" id="addLigne" (click)="rowIndexEdit = -1;showFormEdit({})">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="rowIndexEdit = -1;showFormEdit({})">Ajouter une ligne</span>
    </div>
    <label class="text-left uppercase text-underline historique col-sm-5"></label>
  </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>

<div class="col-sm-12 detail" style="height: 100%; padding: 0px" *ngIf="isEdit" #formEdit
     (click)="common.outSide($event)">
  <div class="modal-header col-sm-12" style="padding: 5px;" (click)="common.outSide($event)">
    <h4
      class="modal-title pull-left col-sm-8"> {{!selectedRow.add ? ('Nomenclature de l\'article : ' + selectedRow.libelle) : 'Ajout d\'un article à la nomenclature'}} </h4>
    <div class="col-sm-4 text-right">
      <button type="button" class="btn-header uppercase" (click)="selectedRow = {};isEdit = false;resetEdit();"> Fermer
      </button>
      <button type="button" class="btn-header uppercase actionPricipal" (click)="validerFormEdit();">
        Valider
      </button>
    </div>
  </div>
  <div class="modalFicheClient col-sm-12">
    <div class="col-sm-12">
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Article :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': selectedRow.id && rowIndexEdit >= 0}">
          <app-autocomplete [placeholder]="'Article'" (searchfunction)="searchArticle($event)"
                            (selectfunction)="setValue($event)" [notOblig]="true" [label]="''"
                            [selectvalue]="true" [results]="dataArticle" [id]="'modedepaie article'"
                            [defaultsearch]="selectedRow ? (selectedRow.code || '') : ''"
                            [autohide]="true" [dropdownclass]="'dropDownPrixNego'"
                            (keyenterfunction)="common.focusNext('.modalFicheClient')"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Libellé :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': true}">
          <div class="form-control" style="border : solid 1px rgba(55, 97, 148, 0.3)">
            {{selectedRow.libelleObjetEntite || selectedRow.libelle || ''}}
          </div>
        </div>
      </div>

      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Article Contenu :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': !isFamille2 }">
          <app-autocomplete [placeholder]="selectedRow.articleContenu ? '' : 'Article Contenu'"
                            (searchfunction)="searchArticleContenu($event)"
                            (selectfunction)="selectedRow.articleContenu = $event;"
                            [notOblig]="true" [label]="''" [selectvalue]="true" [results]="artContenu"
                            [id]="'modedepaie artContenu'"
                            [defaultsearch]="selectedRow.articleContenu ? (selectedRow.articleContenu.libelle || selectedRow.articleContenu.libelleObjetEntite) : artContenu[0].libelleObjetEntite.libelleObjetEntite"
                            [autohide]="true" (keyenterfunction)="common.focusNext('.modalFicheClient');"
                            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Contenant :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px" [ngClass]="{'disabledbutton': isFamille2 }">
          <app-autocomplete (selectfunction)="selectedRow.typeContenant = $event;" [isCombo]="true"
                            [results]="typeContenant"
                            [highlight]="true" [label]="''" id="modedepaie typecontenants" [selectvalue]="true"
                            [placeholder]="'Type contenant'" [defaultselected]="selectedRow.typeContenant"
                            [defaultsearch]="selectedRow.typeContenant ? selectedRow.typeContenant.libelleObjetEntite : typeContenant[0].libelleObjetEntite"
                            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Chantier :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px"
             [ngClass]="{'disabledbutton': selectedRow.agence && selectedRow.agence.id}">
          <app-autocomplete [placeholder]="'Chantier'" (searchfunction)="searchChantier($event)" [selectvalue]="true"
                            (selectfunction)="selectedRow.chantier = $event;" [results]="listChantier"
                            [showonclick]="true"
                            [container] = "true"
                            [label]="''" id="modedepaie autoCht"
                            [defaultsearch]="selectedRow.chantier && selectedRow.chantier.id ? selectedRow.chantier.numChantier : 'Tous'"
                            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Agence :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px"
             [ngClass]="{'disabledbutton': selectedRow.chantier && selectedRow.chantier.id}">
          <app-autocomplete (selectfunction)="selectedRow.agence = $event;" [results]="listeAgence"
                            [highlight]="true" [id]="'modedepaie agence'" [isCombo]="true"
                            [defaultselected]="selectedRow.agence"
                            [defaultsearch]="selectedRow.agence ? selectedRow.agence.libelleObjetEntite : listeAgence[0].libelleObjetEntite"
                            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
      <div class="form-group items col-sm-12">
        <label class="col-sm-5 champ" style="padding:0px">
          Exutoire :
        </label>
        <div class="col-sm-7 champ" style="padding-right: 0px">
          <app-autocomplete [placeholder]="'Exutoire'" (searchfunction)="searchExutoire($event)"
                            [id]="'modedepaie exutoire'"
                            (selectfunction)="selectedRow.exu = $event" [results]="listExutoire" [showonclick]="true"
                            [selectvalue]="true"
                            [label]="''" [defaultselected]="selectedRow.exu"
                            [defaultsearch]="selectedRow.exu ? (selectedRow.exu.libelleObjetEntite || selectedRow.exu.nom) : listExutoire[0].libelleObjetEntite"
                            [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
        </div>
      </div>
    </div>
    <div class="col-sm-12">
      <div class="col-sm-12" style="padding: 0;">
        <div class="addLigne col-sm-12 uppercase" style="position: relative; background-color: #fff;">
          <div class="col-sm-7 text-left" style="padding: 0;">
            <button class="btn-add" (click)="addLigneDetail()">
              <i class="fa fa-plus"></i>
            </button>
            <span (click)="addLigneDetail()" style="padding-left: 10px;">Ajouter une ligne</span>
          </div>
          <h5 class="col-sm-5 text-right" style="padding: 0;"> Liste des articles </h5>
        </div>
      </div>
      <div class="col-sm-12 tableArticle" style="padding: 5px; "
           [ngClass]="{'showQteSupp': showQteSupp, 'notshowQteSupp': !showQteSupp}">
        <ngx-datatable class="material" [rows]="selectedRow.listArtNomenclature || []" style="height: 100%;"
                       [columnMode]="'force'"
                       [headerHeight]="30" [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'single'"
                       [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de tarification à afficher'}"
                       [loadingIndicator]="loadingIndicator">

          <ngx-datatable-column name="article" prop="article.code">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                         let-sort="sortFn">
              <div class="tableheader">
                <span class="uppercase"> Article </span>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
              <div style="overflow: hidden;">
                <app-autocomplete (searchfunction)="searchArticle($event)"
                                  (selectfunction)="setArticle($event, row);common.focusNext('.tableArticle');"
                                  [placeholder]="''" [notOblig]="true" [label]="''" [selectvalue]="true"
                                  [results]="dataArticle" [id]="'detailfact articleListe' + rowIndex "
                                  [defaultsearch]="row ? row.code : ''" [autohide]="true"
                                  [container]="true"
                                  (keyenterfunction)="common.focusNext('.tableArticle');"></app-autocomplete>
              </div>
            </ng-template>
          </ngx-datatable-column>

          <ngx-datatable-column name="article" prop="article.libelle">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                         let-sort="sortFn">
              <div class="tableheader">
                <span class="uppercase"> Libellé </span>
              </div>
            </ng-template>
            <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
              <div style="overflow: hidden;">
                 {{row.libelle || row.libelleObjetEntite || ''}}
              </div>
            </ng-template>
          </ngx-datatable-column>


          <ngx-datatable-column name="pourcentageNomenclature" prop="pourcentageNomenclature">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                         let-sort="sortFn">
              <div class="tableheader">
                <span class="uppercase"> Valeur </span>
              </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              <div><input type="number" step="0.001" class="input detailfact" [(ngModel)]="row.pourcentageNomenclature">
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="unitaire" prop="unitaire">
            <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                         let-sort="sortFn">
              <div class="tableheader">
                <span class="uppercase"> Unitaire </span>
              </div>
            </ng-template>
            <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
              <div style="overflow: hidden;">
                <mat-checkbox class="example-margin" color="primary" [(ngModel)]="row.unitaire"></mat-checkbox>
              </div>

            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="50">
            <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
              <button class="btn-detail" (click)="deleteLigneDetail(row)">
                <i class="fa fa-trash"></i>
              </button>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg">
          {{ erreur }}
        </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>
